
function generateValues<T>(obj: T) {
  const PREFIX = 'BIXI';
  Object.keys(obj).forEach(key => {
    obj[key] = `${PREFIX}_${key}`.toUpperCase();
  });
  return obj;
}

export const COMMON_EVENTS = generateValues({
  ready: '',
  page_number_change: '',
  history_change: '',
  search_result: '',
  pdf_scrolling: '',
  pdf_load_failed: '',
  magnifier_change: '',
  viewports_change: '',
  keydown: ''
});

export const LABEL_EVENTS = generateValues({
  ...COMMON_EVENTS,
  create_labels: '',
  drag_labels: '',
  resize_labels: '',
  delete_labels: '',
  click_labels: '',
  mouse_enter_labels: '',
  mouse_leave_labels: ''
});

export const TABLE_EVENTS = generateValues({
  ...COMMON_EVENTS,
  view_tables_change: '',
  create_tables: '',
  update_tables: '',
  delete_tables: '',
  click_tables: '',
  mouse_enter_tables: '',
  mouse_leave_tables: '',
  merge_tables: '',
  split_tables: '',
  update_ir_tables: '',
  create_ir_table_cells: ''
});

export const SHAPE_EVENTS = generateValues({
  ...COMMON_EVENTS,
  create_shapes: '',
  click_shapes: '',
  delete_shapes: '',
  update_shapes: '',
  doms_change: ''
});
